import type { PersonalDataAccessPayload } from '@massilia/contracts'

import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { writeQuoteToken } from './quote-token.js'

/**
 * Échange le token du mail — ou le nom de famille — contre un jeton d'accès.
 * Le jeton est gardé pour la session : le client ne revérifie pas à chaque
 * navigation dans la page.
 */
export const useGrantQuoteAccessMutation = () =>
  useMutation({
    mutationFn: async ({
      responseId,
      ...payload
    }: PersonalDataAccessPayload & { responseId: string }) => {
      const response = await apiClient.client.post<{ accessToken: string }>(
        `/public/estimate-responses/${responseId}/access`,
        payload
      )

      writeQuoteToken(responseId, response.data.accessToken)

      return response.data
    },
  })
